export default {
  platform_access: {
    name: 'Login na plataforma',
    description: 'Acesso à plataforma web'
  },
  api_access: {
    name: 'Uso da API (total)',
    description: 'Acesso à API'
  },
  account_create: {
    name: 'Multicontas (criação de contas)',
    description: 'Criação de contas'
  },
  user_create: {
    name: 'Criar usuário',
    description: 'Criação de usuários'
  },
  api_credentials_generate: {
    name: 'Gerar credenciais de API',
    description: 'Geração de credenciais de API'
  },
  payin_pix: {
    name: 'Payin (Pix)',
    description: 'Recebimentos via Pix'
  },
  payin_ted: {
    name: 'Payin (TED)',
    description: 'Recebimentos via TED'
  },
  payin_credit_card: {
    name: 'Payin (cartão de crédito)',
    description: 'Recebimentos via cartão de crédito'
  },
  payin_boleto: {
    name: 'Recebimento (Boleto)',
    description: 'Geração de Boletos'
  },
  payin_refund: {
    name: 'Devoluções (Payin)',
    description: 'Estornos de recebimentos'
  },
  payin_cancel: {
    name: 'Cancelar recebimento',
    description: 'Cancelamento de recebimentos'
  },
  qrcode_generate: {
    name: 'Gerar QR Code',
    description: 'Geração de QR Codes'
  },
  payment_link_generate: {
    name: 'Gerar link de pagamentos',
    description: 'Geração de Links de Pagamento'
  },
  payout_automatic_pix: {
    name: 'Pix Automático',
    description: 'Pagamentos automáticos via Pix'
  },
  payout_pix: {
    name: 'Payout (Pix)',
    description: 'Pagamentos via Pix'
  },
  payout_ted: {
    name: 'Payout (TED)',
    description: 'Pagamentos via TED'
  },
  payout_boleto: {
    name: 'Payout (Boleto)',
    description: 'Pagamentos via Boleto'
  },
  payout_pix_refund: {
    name: 'Devoluções (Payout)',
    description: 'Estornos de pagamentos via Pix'
  },
  contacerta_validation: {
    name: 'Validações (Conta Certa)',
    description: 'Validação de dados no ContaCerta'
  },
  balance_withdrawal: {
    name: 'Saque de saldo',
    description: 'Saques de saldo'
  },
  pix_key_register: {
    name: 'Registrar chave Pix',
    description: 'Registro de chaves Pix'
  },
  pix_key_delete: {
    name: 'Excluir chave Pix',
    description: 'Exclusão de chaves Pix'
  },
  pix_key_accept_portability: {
    name: 'Aceitar portabilidade de chave Pix',
    description: 'Aceitação de portabilidade de chaves Pix'
  },
  pix_key_dict_query: {
    name: 'Consultar chave Pix no DICT',
    description: 'Consulta de chave Pix no DICT.'
  },
  infractions_manage: {
    name: 'Gerenciar infrações',
    description: 'Gerenciamento de infrações'
  }
};
